// src/components/auth/AppBootGate.tsx
//
// H-2C2 WP-6 — the boot-gate selector.
//
// The single flag conditional for the OIDC RP migration: when
// `HANDOFF_OIDC_CRM_ENABLED` (`VITE_HANDOFF_OIDC_CRM`) is ON it mounts the new
// `RpBootGate` (BFF model, consumes `GET /auth/context`); otherwise it mounts
// the existing Bearer-model `BootGate`, entirely unchanged. The two boot paths
// run in parallel — neither knows about the other — and this component is the
// only place that chooses between them.

import { type ReactNode } from 'react';

import { HANDOFF_OIDC_CRM_ENABLED } from '../../config/centralAuth';
import BootGate from './BootGate';
import RpBootGate from './RpBootGate';

interface AppBootGateProps {
  children: ReactNode;
}

export default function AppBootGate({ children }: AppBootGateProps) {
  if (HANDOFF_OIDC_CRM_ENABLED) {
    return <RpBootGate>{children}</RpBootGate>;
  }
  return <BootGate>{children}</BootGate>;
}
